import angular from 'angular';

import 'ng-sortable';
import 'angular-animate';
import 'angular-local-storage';
import 'angular-material';
import 'angular-utils-pagination';
import 'ngreact';
import 'sfa-angular-utils';
import 'trix';

import config from './app_config';
import PostCreativeTagData from './providers/post_creative_tag_data';
import persistQueryParams from './persist_query_params';
import uiRouterFix from './z_routing_shiv';

import './ad_builder/module';
import './analytics/module';
import './creatives/module';
import './creative_preview/module';
import './headlines/module';
import './shared/module';
import './sites/module';
import './thumbnails/module';
import './dsp/module';
import './enhanced_ads/module';

// https://github.com/danialfarid/ng-file-upload/pull/2020
// hide unhandled rejection errors until we can upgrade ng-file-upload or
// replace it
angular
  .module('generator', [
    'ui.router',
    'angularUtils.directives.dirPagination',
    'as.sortable',
    'generator.enhanced_ads',
    'generator.adBuilder',
    'generator.analytics',
    'generator.creativePreview',
    'generator.creatives',
    'generator.dsp',
    'generator.headlines',
    'generator.shared',
    'generator.sites',
    'generator.thumbnails',
    'ngAnimate',
    'angular-clipboard',
    'ngMaterial',
    'pascalprecht.translate',
    'LocalStorageModule',
    'react'
  ])
  .config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
    // Add a state for the disabled page with improved styling
    $stateProvider.state('disabled', {
      url: '/disabled',
      template: `
        <div class="p4 text-center">
          <div class="mb4">
            <img 
              class="mb3"
              width="240" 
              src="https://legacy-design-assets.s3.amazonaws.com/images/cactus@2x.png"
            />
            <h3 class="fw-med txt-knight mb3">Feature Disabled</h3>
            <p class="txt-knight-light fs-med mb2">
              Users can no longer create, update or delete objects on the NAG,
            </p>
            <p class="txt-knight-light fs-med mb4">
              as we're planning on shutting down this application shortly.
            </p>
            <a ui-sref="creativePreview.home" class="btn btn-primary">
              Return to Home
            </a>
          </div>
        </div>
      `
    });

    // Redirect forbidden paths
    $urlRouterProvider.when(/\/(new|edit|create|update).*/, function($match) {
      console.log('Redirecting forbidden path:', $match);
      return '/disabled';
    });
  }])
  .config(config)
  .config([
    '$qProvider',
    $qProvider => {
      $qProvider.errorOnUnhandledRejections(false);
    }
  ])
  .run(persistQueryParams)
  .run(uiRouterFix)
  .service('PostCreativeTagData', PostCreativeTagData)
  .run(['$rootScope', '$state', '$transitions', '$location', 
    function($rootScope, $state, $transitions, $location) {
      // Add backup route protection
      $transitions.onBefore({}, function(trans) {
        const toUrl = trans.to().url;
        if (toUrl && toUrl.match(/\/(new|edit|create|update)/)) {
          return trans.router.stateService.target('disabled');
        }
      });
    }
  ]);
